import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { platformAdminService } from '../../services/platformAdmin.service';

export default function PlatformAdminLink({ collapsed = false, onClick }: { collapsed?: boolean; onClick?: () => void }) {
  const { user } = useAuth();
  const [allowed, setAllowed] = React.useState(false);
  React.useEffect(() => {
    let current = true;
    setAllowed(false);
    if (user.userId) platformAdminService.me().then(data => { if (current) setAllowed(data.platform_admin); }).catch(() => {});
    return () => { current = false; };
  }, [user.userId, user.companyId]);
  if (!allowed) return null;
  return <Link to="/platform" onClick={onClick} title="Platform administration"
    className="mx-3 mb-3 flex items-center gap-3 rounded-lg border border-white/10 px-3 py-2.5 text-sm text-white hover:bg-white/10">
    <ShieldCheck size={20} className="shrink-0" /><span className={collapsed ? 'lg:hidden' : ''}>Platform administration</span>
  </Link>;
}
